import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import styled from 'styled-components';
import type { CommonBasicTextProps } from '~/components/common/text/commonBasicTextCss';
import { commonBasicTextCss } from '~/components/common/text/commonBasicTextCss';

interface Props extends ComponentPropsWithoutRef<'span'>, CommonBasicTextProps {
  children: ReactNode;
  className?: string;
}

const Container = styled.span<CommonBasicTextProps>`
  ${(props) => commonBasicTextCss(props)}
`;

export const BasicSpan = ({
  size,
  pcSize,
  colorStyle = 'main',
  weight = 'normal',
  letterSpacing,
  lineHeight,
  fontFamily,
  children,
  className,
  truncateLine,
  fontStyle,
  whiteSpace,
  textAlign,
}: Props) => {
  return (
    <Container
      size={size}
      className={className}
      pcSize={pcSize || size}
      colorStyle={colorStyle}
      weight={weight}
      letterSpacing={letterSpacing}
      lineHeight={lineHeight}
      fontFamily={fontFamily}
      truncateLine={truncateLine}
      fontStyle={fontStyle}
      whiteSpace={whiteSpace}
      textAlign={textAlign}
    >
      {children}
    </Container>
  );
};
